import React from "react";

export function PaymentMethod() {
  return <p>Medio de cobro.</p>;
}
